export const SERVICES = [
  {
    id: "solar-procurement-advisory",
    icon: "Network",
    title: "Solar Procurement Advisory",
    text: "Advising C&I consumers on how to procure solar: defining the requirement, choosing the right route to market and engaging developers in a structured way.",
  },
  {
    id: "energy-assessment",
    icon: "Gauge",
    title: "Energy Requirement Assessment",
    text: "Reviewing consumption, load profile, tariff category and site conditions to understand what your requirement really is.",
  },
  {
    id: "feasibility",
    icon: "ScanSearch",
    title: "Techno-Commercial Feasibility",
    text: "Evaluating which solar models may be technically possible and commercially sensible for your situation.",
  },
  {
    id: "proposal-evaluation",
    icon: "FileSearch",
    title: "Proposal Evaluation",
    text: "Comparing developer and EPC proposals on a like-for-like basis: scope, assumptions, tariffs, terms and risks.",
  },
  {
    id: "partner-identification",
    icon: "Handshake",
    title: "Developer & EPC Identification",
    text: "Identifying implementation partners whose capabilities, geography and commercial models suit your project.",
  },
  {
    id: "project-coordination",
    icon: "Workflow",
    title: "Project Coordination",
    text: "Keeping consumers, developers and EPC teams aligned on milestones, documentation and decisions.",
  },
  {
    id: "regulatory-coordination",
    icon: "ShieldCheck",
    title: "Regulatory Approval Coordination",
    text: "Coordinating the documentation and follow-up involved in applicable approvals, alongside the consumer and developer.",
  },
  {
    id: "land-identification",
    icon: "MapPinned",
    title: "Utility-Scale Land Identification",
    text: "Supporting the identification of land parcels for utility-scale and open access solar projects.",
  },
  {
    id: "ppa-facilitation",
    icon: "FileSignature",
    title: "Commercial & PPA Facilitation",
    text: "Supporting commercial discussions and Power Purchase Agreement negotiations, working with your legal advisors.",
  },
];
